<template>
  <v-flex>
    <v-btn icon class="mx-0" @click.native="addProject"><v-icon>add</v-icon></v-btn>
    <v-data-table :headers="headers" :loading="loadingState" :items="projects" hide-actions class="elevation-1">
      <template slot="items" slot-scope="props">
        <td class="text-xs-left">{{ props.item.id }}</td>
        <td class="text-xs-left">{{ props.item.name }}</td>
        <td class="text-xs-left">{{ props.item.description }}</td>
        <td class="text-xs-left">{{ props.item.status }}</td>
        <td class="justify-center layout px-0">
          <v-btn icon class="mx-0" @click.native="displayInfo(props.item.id)"><v-icon>info</v-icon></v-btn>
          <v-btn icon class="mx-0" @click.native="editItem(props.item.id)"><v-icon>edit</v-icon></v-btn>
          <v-btn v-if="env !== 'production'" icon class="mx-0" @click.native="openImportDialog(props.item.id, props.item.uuid)">
            <v-icon>import_export</v-icon>
          </v-btn>
          <v-btn icon class="mx-0" @click.native="deleteItem(props.item)"><v-icon>delete</v-icon></v-btn>
        </td>
      </template>
      <template slot="no-data">
        <v-alert :value="true" color="error" icon="warning" outline>No data available</v-alert>
      </template>
    </v-data-table>
    
    <v-dialog v-model="importDialog" max-width="800px" persistent>
      <v-card>
        <v-card-text>
          <v-container grid-list-md text-xs-center>
            <v-layout row wrap>
              <v-flex xs12>
                <v-text-field v-model="importDbUrl" label="Database URL" required @blur="$v.importDbUrl.$touch()" :error-messages="importDbUrlErrorMsgs"></v-text-field>
              </v-flex>
              <v-flex xs6>
                <v-text-field v-model="importDbUser" label="Database User" required @blur="$v.importDbUser.$touch()" :error-messages="importDbUserErrorMsgs"></v-text-field>
              </v-flex>
              <v-flex xs6>
                <v-text-field v-model="importDbPass" label="Database Password" required @blur="$v.importDbPass.$touch()" :error-messages="importDbPassErrorMsgs"></v-text-field>
              </v-flex>
              <v-flex xs3>
                <v-text-field v-model="tweetsLimit" label="Tweets Limit"></v-text-field>
              </v-flex>
              <v-flex xs3>
                <v-text-field v-model="tweetsOffset" label="Tweets Offset"></v-text-field>
              </v-flex>
              <v-flex xs3>
                <v-text-field v-model="articlesLimit" label="Articles Limit"></v-text-field>
              </v-flex>
              <v-flex xs3>
                <v-text-field v-model="articlesOffset" label="Articles Offset"></v-text-field>
              </v-flex>
              <v-flex xs6>
                <v-checkbox v-model="importTweets" label="Import Tweets"></v-checkbox>
              </v-flex>
              <v-flex xs6>
                <v-checkbox v-model="importArticles" label="Import Articles"></v-checkbox>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        
        <v-card-actions>
          <v-btn color="primary" flat @click.stop="submitImport()">Import</v-btn>
          <v-btn color="primary" flat @click.stop="closeImportDialog()">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-flex>
</template>

<script>
import axios from 'axios'
import vh, { importDbUrl, importDbUser, importDbPass } from '@/helpers/validators'
import config from '@/helpers/config'
import { mapGetters, mapMutations } from 'vuex'

export default {
  data: function () {
    return {
      loadingState: true,
      importDialog: false,
      importProjectId: null,
      importProjectUuid: null,
      importDbUrl: null,
      importDbUser: null,
      importDbPass: null,
      tweetsLimit: null,
      tweetsOffset: null,
      articlesLimit: null,
      articlesOffset: null,
      importTweets: false,
      importArticles: false,
      headers: [
      { text: 'ID', align: 'left', value: 'id' },
      { text: 'Name', align: 'left', value: 'name' },
      { text: 'Description', align: 'left', value: 'description' },
      { text: 'Status', align: 'left', value: 'status' },
      { text: '', align: 'left', value: 'actions', sortable: false } ]
    }
  },
  validations: {
    importDbUrl: vh.vrules(importDbUrl),
    importDbUser: vh.vrules(importDbUser),
    importDbPass: vh.vrules(importDbPass)
  },
  computed: {
    ...mapGetters({
      projects: 'getProjects'
    }),
    env () {
      return config.env
    },
    importDbUrlErrorMsgs () {
      if (this.$v.importDbUrl.$dirty) {
        return vh.vmsg(this.$v.importDbUrl, importDbUrl)
      } else {
        return []
      }
    },
    importDbUserErrorMsgs () {
      if (this.$v.importDbUser.$dirty) {
        return vh.vmsg(this.$v.importDbUser, importDbUser)
      } else {
        return []
      }
    },
    importDbPassErrorMsgs () {
      if (this.$v.importDbPass.$dirty) {
        return vh.vmsg(this.$v.importDbPass, importDbPass)
      } else {
        return []
      }
    }
  },
  methods: {
    ...mapMutations('notification', ['notify']),
    ...mapMutations('loading', ['showLoading', 'hideLoading']),
    getData () {
      this.loadingState = true
      axios.all([this.$store.dispatch('getProjects')]).then(axios.spread((projectsResponse) => {
        this.loadingState = false
        if (projectsResponse.data.status === 'SUCCESS') this.$store.commit('setProjects', projectsResponse.data.payload)
      })).catch((err) => {
        this.loadingState = false
        this.notify({message: 'Something went wrong while connecting to the server.', show: true})
        console.log(err)
      })
    },
    datify: function (date) {
      if (!date) {
        return
      }
      return date.time.hour + ':' + date.time.minute + ' ' + date.date.day + '/' + date.date.month + '/' + date.date.year
    },
    editItem (id) {
      this.$router.push('/projects/' + id)
    },
    addProject () {
      this.$router.push('/projects/new')
    },
    displayInfo (id) {
      this.$router.push('/projects/details/' + id)
    },
    openImportDialog (id, uuid) {
      this.importDialog = true
      this.importProjectId = parseInt(id)
      this.importProjectUuid = uuid
    },
    closeImportDialog () {
      this.importDialog = false
      this.importProjectId = null
      this.importProjectUuid = null
      this.importDbUrl = null
      this.importDbUser = null
      this.importDbPass = null
      this.importTweets = false
      this.importArticles = false
      this.tweetsLimit = null
      this.tweetsOffset = null
      this.articlesLimit = null
      this.articlesOffset = null
    },
    submitImport () {
      this.$v.$touch()
      if (this.$v.$invalid) {
        return
      }

      let conf = {
        databaseUrl: this.importDbUrl,
        databaseUser: this.importDbUser,
        databasePassword: this.importDbPass,
        projectId: parseInt(this.importProjectId),
        projectUuid: this.importProjectUuid,
        importTweets: Boolean(this.importTweets),
        importArticles: Boolean(this.importArticles),
        tweetsLimit: Number(this.tweetsLimit) >= 0 ? Number(this.tweetsLimit) : 0,
        tweetsOffset: Number(this.tweetsOffset) >= 0 ? Number(this.tweetsOffset) : 0,
        articlesLimit: Number(this.articlesLimit) >= 0 ? Number(this.articlesLimit) : 0,
        articlesOffset: Number(this.articlesOffset) >= 0 ? Number(this.articlesOffset) : 0
      }

      axios.all([this.$store.dispatch('importDB', conf)]).then(axios.spread((r) => {
        if (r.data.status === 'SUCCESS') {
          this.notify({message: r.data.message, show: true})
          this.closeImportDialog()
        } else {
          this.notify({message: 'Something went wrong while trying to start import job.', show: true})
        }
      })).catch(() => {
        this.notify({message: 'Something went wrong while connecting to the server.', show: true})
      })
    },
    deleteItem (item) {
      let message = 'Are you sure you want to delete project "' + item.name + '" ? This action will also drop the respective GNIP Rules (the database will remain intact).'
      this.$vuetifyConfirmDialog.open('', message, 'Cancel', 'Delete').then(state => {
        if (state) {
          this.showLoading('')
          this.deleteGNIPRule(item)
        }
      })
    },
    deleteGNIPRule (item) {
      axios.all([this.$store.dispatch('deleteGNIPRule', {tag: item.uuid})]).then(axios.spread((gnipResponse) => {
        if (gnipResponse.data.status === 'SUCCESS') {
          this.deleteProject(item)
        } else {
          let message = 'Something went wrong while deleting GNIP rule. Do you still want to delete the project? (the rule will have to be deleted manually)'
          this.$vuetifyConfirmDialog.open('', message, 'Cancel', 'Delete').then(state => {
            if (state) {
              this.showLoading('')
              this.deleteProject(item)
            } else {
              this.hideLoading()
            }
          })
        }
      })).catch((err) => {
        console.log(err)
        let message = 'Something went wrong while deleting GNIP rule. Do you still want to delete the project? (the rule will have to be deleted manually)'
        this.$vuetifyConfirmDialog.open('', message, 'Cancel', 'Delete').then(state => {
          if (state) {
            this.showLoading('')
            this.deleteProject(item)
          } else {
            this.hideLoading()
          }
        })
      })
    },
    deleteProject (item) {
      axios.all([this.$store.dispatch('deleteProject', {id: parseInt(item.id)})]).then(axios.spread((projectResponse) => {
        if (projectResponse.data.status === 'SUCCESS') {
          this.$store.commit('deleteProject', projectResponse.data.payload)
        } else {
          this.notify({message: 'Something went wrong while deleting the project. Please try again.', show: true})
        }
        this.hideLoading()
      })).catch((err) => {
        this.hideLoading()
        console.log(err)
      })
    }
  },
  mounted: function () {
    this.getData()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/projects/ProjectsTable.vue